export default __webpack_public_path__ + "static/03-b-underline-inclusive-b7340c46b1a6341609641449d1c542e0.svg";